import React, { useEffect, useState } from "react";
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from "primereact/multiselect";
import { getRolesData } from "../../store/rolesData/getRolesdata";
import { useDispatch } from "react-redux";

export const RoleNames = (props) => {
    const [rolesData, setRolesData] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getRolesData()).then((res) => {
            if (res.payload.status === 200) {
                const data = res.payload.data.map(item => {
                    return { key: item.roleName, val: item.roleName, id: item._id }
                })
                setRolesData(data);

            }
        })
    }, [])

    return (
        <div className="rc_mutiselet_dropdown">
            {props.controlConfig?.selectionMode == "multiple" ?
               
                <MultiSelect
                    disabled={!props.controlConfig.editable}
                    id={props.field.name}
                    className={props.propsclassName}
                    appendTo='self'
                    value={props.field.value}
                    options={rolesData}
                    optionLabel="key"
                    dropdownIcon="fa fa-caret-down"
                    
                    placeholder={rolesData.length === 0 ? <span>Loading...</span> : props?.controlConfig?.htmlAttributes?.placeholder}
                    onChange={(e) => props.field.onChange(e.value)}
                /> :
                <Dropdown dropdownIcon="fa fa-caret-down"
                    id={props.field.name}
                    className={props.propsclassName}
                    {...props.controlConfig?.htmlAttributes} optionLabel="key"
                    value={props.field.value}
                    placeholder={rolesData.length === 0 ? <span>Loading...</span> : props?.controlConfig?.htmlAttributes?.placeholder}
                    appendTo={'self'}
                    onChange={(e) => props.field.onChange(e.value)}
                    options={rolesData} />}
        </div>
    )
}